export default class PasswordValidator extends HTMLDivElement {
    constructor() {
        super();
        this.input = null;
        this.helpBlock = null;
        this._hadServerError = false;
        this._onInput = this._onInput.bind(this);
    }

    connectedCallback() {
        // Optionally, you can set a selector via attribute, e.g. <div is="password-validator" data-input="#password">
        const inputSelector = this.getAttribute('data-input') || 'input[type="password"]';
        this.input = document.querySelector(inputSelector);
        // Cherche un help-block à proximité du champ (dans le même groupe de formulaire si possible)
        if (this.input) {
            const container = this.input.closest('.mb-3, .form-group, .input-group') || this.input.parentElement;
            // Ne cherche le help-block que dans le conteneur du champ
            this.helpBlock = container ? container.querySelector('.help-block') : null;
            // Marque une erreur serveur initiale si un help-block est présent avec contenu
            this._hadServerError = !!(this.helpBlock && this.helpBlock.children && this.helpBlock.children.length > 0);
        }
        if (this.input) {
            this.input.addEventListener('input', this._onInput);
        }
    }

    disconnectedCallback() {
        if (this.input) {
            this.input.removeEventListener('input', this._onInput);
        }
    }

    _onInput() {
        // Supprimer le .help-block s'il est présent dans le closest .col-md-6
        if (this.input) {
            const col = this.input.closest('.col-md-6');
            if (col) {
            const help = col.querySelector('.help-block');
            if (help) {
                help.remove();
            }
            }
        }
        const value = this.input ? this.input.value : '';
        this._updateRequirement('length', value.length >= 8);
        this._updateRequirement('uppercase', /[A-Z]/.test(value));
        this._updateRequirement('lowercase', /[a-z]/.test(value));
        this._updateRequirement('number', /[0-9]/.test(value));
        this._updateRequirement('special', /[^A-Za-z0-9]/.test(value));
    }

    _updateRequirement(requirement, isValid) {
        const el = this.querySelector(`.password-requirement[data-requirement="${requirement}"]`);
        if (!el) return;
        const [iconInvalid, iconValid] = el.querySelectorAll('i');
        if (isValid) {
            iconInvalid.classList.add('d-none');
            iconValid.classList.remove('d-none');
        } else {
            iconInvalid.classList.remove('d-none');
            iconValid.classList.add('d-none');
        }
    }
}